module.exports = __webpack_public_path__ + "bf46b0a4fabd7aac779e4ffa44df8b22.svg";